import { render, staticRenderFns } from "./TimelineRoot.vue?vue&type=template&id=3bde0e37&scoped=true&"
import script from "./TimelineRoot.vue?vue&type=script&lang=ts&"
export * from "./TimelineRoot.vue?vue&type=script&lang=ts&"
import style0 from "./TimelineRoot.vue?vue&type=style&index=0&id=3bde0e37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde0e37",
  null
  
)

export default component.exports